import { injectable } from 'inversify';

import {
  InfoTemplateResponse,
  PlaceholderKey,
  TemplatePlaceholder,
} from '@app/gen/templates';

@injectable()
export class SettingsTemplatesPreviewMapper {
  processKey(key: PlaceholderKey) {
    return key.replace(/[.]/g, '___');
  }

  processAttribute(attribute: TemplatePlaceholder) {
    return {
      name: this.processKey(attribute.key),
      type: attribute.type,
      readOnly: attribute.is_generic,
      label: attribute.label,
      placeholder: attribute.placeholder,
    };
  }

  processInitialValues(attributes?: TemplatePlaceholder[]) {
    const initialValues: Record<string, string | undefined> = {};

    attributes?.forEach(({ key, value }) => {
      initialValues[this.processKey(key)] = value;
    });

    return initialValues;
  }

  processTemplatePreviewInfo(preview: InfoTemplateResponse) {
    return {
      companyName: preview.company.name,
      templateName: preview.name,
      eventTypes: preview.event_types
        ?.map((eventType) => eventType.name)
        .join(', '),
    };
  }

  processTemplatePreviewForm(placeholders: TemplatePlaceholder[]) {
    return {
      editableAttributes: placeholders
        ?.filter((item) => !item.is_generic)
        .map((item) => this.processAttribute(item)),
      readOnlyAttributes: placeholders
        ?.filter((item) => item.is_generic && item.in_file)
        .map((item) => this.processAttribute(item)),
      initialValues: this.processInitialValues(placeholders),
    };
  }
}
